import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { AutomotiveAftermarketFiltersFacade } from './automotive-aftermarket-filters.facade';

@Injectable({
  providedIn: 'root',
})
export class AutomotiveAftermarketFiltersGuard {
  constructor(private automotiveAftermarketFiltersFacade: AutomotiveAftermarketFiltersFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.automotiveAftermarketFiltersFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.automotiveAftermarketFiltersFacade);
  }
}
